import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import {
  deletePeerPoolDiscipline,
  loadAllPeerPoolDisciplines,
} from '../../store/global-settings.actions';
import { openDeleteConfirmationDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { PeerPoolDisciplineDetailsDialogComponent } from '../../components/peer-pool-discipline-details-dialog/peer-pool-discipline-details-dialog.component';

@Component({
  standalone: false,
  selector: 'app-peer-pool-disciplines',
  templateUrl: './peer-pool-disciplines.component.html',
  styleUrls: ['./peer-pool-disciplines.component.scss'],
})
export class PeerPoolDisciplinesComponent {
  constructor(private store: Store<AppState>, private dialog: MatDialog) {
    this.store.dispatch(loadAllPeerPoolDisciplines());
  }

  addPeerPoolDiscipline() {
    this.openPeerPoolDisciplineFormDialog();
  }

  editPeerPoolDiscipline(peerPoolDisciplineId: string) {
    this.openPeerPoolDisciplineFormDialog(peerPoolDisciplineId);
  }

  deletePeerPoolDiscipline(peerPoolDisciplineId: string) {
    this.store.dispatch(
      openDeleteConfirmationDialog({
        onConfirm: () => {
          this.store.dispatch(
            deletePeerPoolDiscipline({ peerPoolDisciplineId })
          );
        },
        description:
          'Are you sure you want to delete the selected mandatory check template? You cannot undo this action.',
      })
    );
  }

  private openPeerPoolDisciplineFormDialog(
    peerPoolDisciplineId: string | null = null
  ) {
    const dialogRef = this.dialog.open(
      PeerPoolDisciplineDetailsDialogComponent,
      {
        panelClass: 'peer-pool-discipline-form-dialog',
        closeOnNavigation: false,
        disableClose: true,
        maxWidth: 'unset',
        data: { isNew: peerPoolDisciplineId == null, peerPoolDisciplineId },
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.closeWindow();
      dialogRef.close();
    });
  }
}
